import useLocale from '@/hooks/useLocale/useLocale';
import * as Styles from './Cards.styles';
import React from 'react';
import { Button } from 'gatorcomponents';

const Cards = ({
  handleClickAccess,
  withGatorProtect,
  shouldRemoveCodeGuard,
  enableGatorBackupFeature,
}) => {
  const { security: securityLocale } = useLocale();
  const handleAccess = (id) => {
    handleClickAccess && handleClickAccess(id);
  };
  return (
    <Styles.Wrapper>
      <Styles.CardsContainer>
        <Styles.CardsTitle>
          {securityLocale.cards.title}
        </Styles.CardsTitle>

        <Styles.CardsWrapper>
          {securityLocale.cards.items.map((item) => {
            if (withGatorProtect && item.id === 'sitelock') return;
            if (!withGatorProtect && item.id === 'gatorProtect') return;
            if (shouldRemoveCodeGuard && item.id === 'codeguard') return;
            if (!enableGatorBackupFeature && item.id === 'gatorBackup') return;

            return (
              <Styles.CardOuterWrapper key={item.id}>
                <Styles.Card data-testid={`card-${item.id}`}>
                  {(item.tag || item.recommended) && (
                    <Styles.CardTagsWrapper>
                      {item.tag && <Styles.CardTag>{item.tag}</Styles.CardTag>}
                      {item.recommended && <Styles.CardTagRecommended>{item.recommended}</Styles.CardTagRecommended>}
                    </Styles.CardTagsWrapper>
                  )}
                  <Styles.CardImageWrapper>
                    <Styles.CardImage src={item.imgSrc} />
                  </Styles.CardImageWrapper>

                  <Styles.CardList>
                    {item.list.map(listItem => (
                      <Styles.CardListItem key={`${item.id}-${JSON.stringify(listItem)}`}>
                        {listItem}
                      </Styles.CardListItem>
                    ))}
                  </Styles.CardList>

                  <Styles.CardActionWrapper>
                    <Button
                      testId={`button-${item.id}-access`}
                      label={item.action}
                      size="medium2"
                      variant="secondary"
                      onClick={() => handleAccess(item.id)}
                    />
                  </Styles.CardActionWrapper>
                </Styles.Card>
              </Styles.CardOuterWrapper>
            );
          })}
        </Styles.CardsWrapper>
      </Styles.CardsContainer>
    </Styles.Wrapper>
  );
};

export default Cards;
